import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'cheatSheets';
export const selectCheatSheetsState = state => state[STORE_KEY];
export const selectCheatSheet = state => selectCheatSheetsState(state).currentCheatSheet;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentCheatSheet: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  rookiesOnly: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;

// ------------------------------------
// Load Cheat Sheet from api
// ------------------------------------
export const LOAD_CHEAT_SHEET_REQUEST = `${STORE_KEY}/LOAD_CHEAT_SHEET_REQUEST`;
export const LOAD_CHEAT_SHEET_SUCCESS = `${STORE_KEY}/LOAD_CHEAT_SHEET_SUCCESS`;
export const LOAD_CHEAT_SHEET_ERROR = `${STORE_KEY}/LOAD_CHEAT_SHEET_ERROR`;

export const loadCheatSheetRequest = (year, week, formulaId, rookiesOnly) => ({
  type: LOAD_CHEAT_SHEET_REQUEST,
  payload: { year, week, formulaId, rookiesOnly },
});
export const loadCheatSheetSuccess = ({ cheatsheet }) => ({
  type: LOAD_CHEAT_SHEET_SUCCESS,
  payload: { cheatsheet },
});
export const loadCheatSheetError = error => ({
  type: LOAD_CHEAT_SHEET_ERROR,
  payload: { error },
});

actions[LOAD_CHEAT_SHEET_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
  rookiesOnly: payload.rookiesOnly,
});
actions[LOAD_CHEAT_SHEET_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  currentCheatSheet: payload.cheatsheet,
});
actions[LOAD_CHEAT_SHEET_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadCheatSheet = (year, week, formulaId, rookiesOnly) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadCheatSheetRequest(year, week, formulaId, rookiesOnly));
    const cheatsheets = await api.cheatSheets.getByWeek(year, week, formulaId, rookiesOnly);
    return dispatch(loadCheatSheetSuccess(cheatsheets));
  } catch (error) {
    console.error(error);
    return dispatch(loadCheatSheetError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View
// ------------------------------------
export const CHEAT_SHEETS_VIEW = `${STORE_KEY}/CHEAT_SHEETS_VIEW`;

viewNames[CHEAT_SHEETS_VIEW] = 'CheatSheets';
routes[CHEAT_SHEETS_VIEW] = {
  path: '/cheatsheets',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { year, week, formulaId, rookiesOnly } = selectQuery(state);
    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;
    if (year === null || year === undefined || year === 'null') year = currentYear;
    await dispatch(loadWeeks(year));
    await dispatch(loadToolDescriptions());

    const projectionsWeeks = [0].concat(selectWeeks(getState(), year, 'projections'));
    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = projectionsWeeks[0];
      }
    }

    if (!(projectionsWeeks.includes(week))) {
      week = projectionsWeeks[0] || 0;
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadCheatSheet(year, week, formulaId, rookiesOnly));
  },
};



// WEBPACK FOOTER //
// ./src/app/views/CheatSheets/module/cheatSheets.js